import React from 'react';
import ModellerDefaults from '../../ModellerDefaults';
import GraphNetworkView from './GraphNetworkView';
import GraphModelView from './GraphModelView';

export default ({
  data, graphKey,
}) => {
  if (graphKey === ModellerDefaults.ModelViewGraphKey) {
    return <GraphModelView data={data} graphKey={graphKey} />;
  }
  return <GraphNetworkView data={data} graphKey={graphKey} />;
};
